export default __webpack_public_path__ + "static/media/btn-primary.9cad93e7.png";